import React, { useState } from 'react';
import './Login.css';
import { useAuth } from '@/contexts/AuthContext';
import { useToast } from '@/hooks/use-toast';
import { useNavigate } from 'react-router-dom';

const RECOVERY_CUTOFF_LABEL = '22/03/2026';

export default function ForgotPassword() {
  const [email, setEmail] = useState('');
  const [isSubmitting, setIsSubmitting] = useState(false);
  const { requestPasswordRecovery } = useAuth();
  const { toast } = useToast();
  const navigate = useNavigate();

  async function handleSubmit(event) {
    event.preventDefault();
    setIsSubmitting(true);

    try {
      await requestPasswordRecovery(email);
      toast({
        title: 'Email enviado',
        description: 'Se o email estiver cadastrado, enviamos as instrucoes para redefinir a senha.',
      });
      navigate('/login', { replace: true });
    } catch (err) {
      if (err?.name === 'AbortError') {
        return;
      }

      const statusCode = Number(err?.statusCode || err?.status || 0);
      let description = err?.getUserFriendlyMessage?.() || err?.message || 'Nao foi possivel enviar o email de recuperacao.';
      if (statusCode === 403) {
        description = `Recuperacao por email disponivel apenas para contas criadas a partir de ${RECOVERY_CUTOFF_LABEL}.`;
      } else if (statusCode === 504) {
        description = 'Timeout ao enviar email. Verifique a configuracao SMTP no Supabase e tente novamente.';
      }

      toast({
        variant: 'destructive',
        title: 'Erro na recuperacao',
        description,
      });
    } finally {
      setIsSubmitting(false);
    }
  }

  return (
    <div className="login-container">
      <div className="login-box auth-card shadow-2xl border border-gray-100">
        <h1 className="login-title">CorreFood</h1>
        <p className="login-subtitle">Recuperar senha por e-mail</p>
        <p className="auth-helper-text text-xs text-gray-500 mt-1">
          Recuperacao por email disponivel para contas criadas a partir de {RECOVERY_CUTOFF_LABEL}.
        </p>

        <form onSubmit={handleSubmit} className="auth-form space-y-4">
          <input
            className="auth-input w-full p-3 rounded-lg border focus:ring-2 focus:ring-orange-500 outline-none"
            type="email"
            placeholder="E-mail cadastrado"
            value={email}
            onChange={(event) => setEmail(event.target.value)}
            required
          />

          <button
            type="submit"
            disabled={isSubmitting}
            className="auth-submit-btn w-full bg-orange-500 hover:bg-orange-600 text-white font-bold py-3 rounded-lg transition-all disabled:opacity-50 disabled:cursor-not-allowed"
          >
            {isSubmitting ? 'Enviando...' : 'Enviar link de recuperacao'}
          </button>
        </form>

        <div className="login-footer">
          <p className="auth-footer-text text-center text-sm text-gray-600 mt-4">
            Lembrou sua senha?{' '}
            <a href="/login" className="text-orange-500 hover:underline font-semibold">
              Voltar para login
            </a>
          </p>
        </div>
      </div>
    </div>
  );
}
